import React from 'react';
import {AuthenticationAsAService} from "./projects/AuthenticationAsAService";
import {DistributedCounter} from "./projects/DistributedCounter";
import {useParams} from "react-router-dom";
import {PageNotFound} from "../PageNotFound";
import styles from '../../styles/portfolio/portfolio_router.scss';


export const PortfolioRouter = props => {
    let { project } = useParams();

    switch(project) {
        case 'authentication-as-a-service':
            return <div className={styles.container}>
                <AuthenticationAsAService/>
            </div>
        case 'distributed-counter':
            return <div className={styles.container}>
                <DistributedCounter/>
            </div>
        default:
            return <PageNotFound/>
    }
};
